import React from "react";
import { Cpu, FlaskConical, ShieldCheck, Users } from "lucide-react";

const pillars = [
  { icon: <Cpu size={18} />, title: "Automated Lines", desc: "High-speed forming and printing machinery." },
  { icon: <FlaskConical size={18} />, title: "QA Lab", desc: "In-house testing for migration and burst." },
  { icon: <ShieldCheck size={18} />, title: "Hygienic Plant", desc: "Controlled environment with food-safe protocols." },
  { icon: <Users size={18} />, title: "Skilled Workforce", desc: "Trained operators following SOPs." },
];

export const Manufacturing = () => {
  return (
    <section data-testid="manufacturing-section" className="relative py-24 md:py-32 bg-neutral-50/60">
      <div className="max-w-7xl mx-auto px-5 md:px-10 grid lg:grid-cols-12 gap-10 items-center">
        <div className="lg:col-span-6 relative rounded-3xl overflow-hidden border border-neutral-200 aspect-[4/3]">
          <img
            src="https://customer-assets.emergentagent.com/job_versacorp-solutions/artifacts/4cnkxmed_photo-1716643863806-989dd76ae093.jpg"
            alt="Manufacturing floor"
            className="absolute inset-0 w-full h-full object-cover"
          />
          <div className="absolute inset-x-6 bottom-6 bg-white/80 backdrop-blur-xl border border-white/60 rounded-2xl p-5 shadow-xl">
            <div className="font-mono-vc text-[10px] uppercase tracking-[0.2em] text-neutral-500">Facility</div>
            <div className="font-display text-xl font-bold text-neutral-900 mt-1">KIADB Industrial Area, Dharwad</div>
            <div className="text-sm text-neutral-600 mt-1">25,000+ sq.ft • Multiple production lines</div>
          </div>
        </div>

        <div className="lg:col-span-6">
          <div className="font-mono-vc text-xs uppercase tracking-[0.25em] vc-text-gradient font-bold">
            Manufacturing Excellence
          </div>
          <h2 className="mt-4 font-display text-4xl md:text-5xl font-extrabold text-neutral-900 leading-[1.05]">
            Precision-engineered at <br />
            <span className="vc-text-gradient">every layer.</span>
          </h2>
          <p className="mt-5 text-neutral-600 leading-relaxed">
            Our state-of-the-art facility blends automation, quality control, and sustainability —
            ensuring every cup, napkin, and container that ships meets our promise of premium quality.
          </p>
          <div className="mt-8 grid sm:grid-cols-2 gap-4">
            {pillars.map((p) => (
              <div key={p.title} className="rounded-2xl border border-neutral-200 bg-white p-5">
                <div className="w-9 h-9 rounded-lg vc-gradient text-white flex items-center justify-center mb-3">
                  {p.icon}
                </div>
                <div className="font-display font-bold text-neutral-900">{p.title}</div>
                <p className="text-sm text-neutral-600 mt-1.5">{p.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
